export default {
  modalName: {
    id: 'service_drawer_name',
    defaultMessage: 'Backup service',
  },
  warranty: {
    id: 'service_drawer_table_warranty',
    defaultMessage: 'Warranty',
  },
  comparisonTable1: {
    id: 'service_drawer_table_benefit1',
    defaultMessage: 'Defects covered ',
  },
  comparisonTable2: {
    id: 'service_drawer_table_benefit2',
    defaultMessage: 'Drops, spills, cracks ',
  },
  comparisonTable3: {
    id: 'service_drawer_table_benefit3',
    defaultMessage: 'Wear and tear',
  },
  comparisonTable4: {
    id: 'service_drawer_table_benefit4',
    defaultMessage: 'Repair or voucher',
  },
}
